<div class="close-btn-outer">
  <button mat-mini-fab color="warn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div mat-dialog-content>
  <div class="d-flex flex-row flex-wrap product-dialog">
    <div class="flex-100 flex-md-50 qv-image pl-1 pr-1">
      <img [src]="product?.images[0]?.medium" />
    </div>
    <div class="flex-100 flex-md-50 mt-2 mt-md-0 px-md-2">
      <h2 class="dialog-title">{{product?.name}}</h2>
      <div class="py-1 lh">
        <p><span *ngIf="product?.availability" class="text-muted fw-500">{{product?.availability}}</span></p>
      </div>
      <p>{{product?.shortDescription}}</p>
      <div class="justify-content-end align-items-center text-muted">
        <button *ngIf="product?.stockQuantity < 1" [mat-dialog-close]="product" mat-raised-button color="accent" matTooltip="Tell me when this is back in stock">
          Tell me when this is back in stock
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <button *ngIf="product?.stockQuantity > 0" [mat-dialog-close]="product" mat-raised-button color="accent" matTooltip="View full details">
          View full details
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
      <div class="divider"></div>
      <div class="d-flex flex-row flex-wrap">
        <div class="old-price text-muted"><span *ngIf="product?.oldPrice && !product.adjustedPrice">{{product?.oldPriceDisplay}}</span></div>
        <div *ngIf="!product.adjustedPrice" class="new-price">{{product?.newPriceDisplay}}</div>
        <div *ngIf="product.adjustedPrice" class="new-price">{{product?.adjustedPriceDisplay}}</div>
        <ng-container *ngIf="!product?.adjustedPrice && product?.newPrice && afterpayLimits && product?.newPrice > afterpayLimits.min && afterpayLimits.max > product?.newPrice">
          <span class="afterpay">or 4 interest free payments of <strong>{{product?.installmentPriceDisplay}}</strong> with
            <a (click)=openAfterpay()>
              <img src="assets/images/payments/logos/ap-logo-152x31.png" alt="Pay with Afterpay" />
            </a>
            <button mat-icon-button [attr.aria-label]="'Learn More'" color="accent" matTooltip="learn more" (click)="openAfterpay()">
              <mat-icon>info</mat-icon>
            </button>
          </span>
        </ng-container>
        <ng-container *ngIf="product?.adjustedPrice && afterpayLimits && product?.adjustedPrice > afterpayLimits.min && afterpayLimits.max > product?.adjustedPrice">
          <span class="afterpay">or 4 interest free payments of <strong>{{product?.adjustedInstallmentPriceDisplay}}</strong> with
            <a (click)=openAfterpay()>
              <img src="assets/images/payments/logos/ap-logo-152x31.png" alt="Pay with Afterpay" />
            </a>
            <button mat-icon-button [attr.aria-label]="'Learn More'" color="accent" matTooltip="learn more" (click)="openAfterpay()">
              <mat-icon>info</mat-icon>
            </button>
          </span>
        </ng-container>
        <div class="flex-100 flex-fill py-1" *ngIf="product?.discounts && product?.discounts.length > 0">
          <span>This product has the follows discounts:</span>
          <ul>
            <li *ngFor="let discount of product?.discounts">{{discount.name}}</li>
          </ul>
        </div>
        <div class="flex-100 flex-fill">
          <app-controls-quickview></app-controls-quickview>
        </div>
      </div>
    </div>
    <div class="afterpay-overlay" *ngIf="afterpayPop">
      <mat-card class="mat-elevation-z4">
        <div class="d-flex flex-column justify-content-around align-items-end">
          <div>
            <button mat-mini-fab color="accent" matTooltip="close" (click)="closeAfterpay()">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div>
            <a href="https://www.afterpay.com/terms/" rel="noreferrer" target="_blank" style="border: none">
              <img class="afterpay-modal-image" src="https://static.secure-afterpay.com.au/banner-large.png" alt="Afterpay">
            </a>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
